import { SxProps, Theme, Typography } from '@mui/material';
import { Color, colors } from '../colors';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TMap } from '../../helpers/types';

export const statusTagTypes = [
  'ok',
  'warn',
  'info',
  'warning',
  'primaryLight',
  'primaryDark',
  'primaryContrast',
] as const;
export type StatusTagType = (typeof statusTagTypes)[number];

const statusColorMap: TMap<StatusTagType, [Color, Color]> = {
  info: ['info', 'infoBg'],
  ok: ['ok', 'okBg'],
  warn: ['warn', 'warnBg'],
  warning: ['warning900', 'warning200'],
  primaryLight: ['primaryMain900', 'primaryLight800'],
  primaryDark: ['primaryDark600', 'secondary200'],
  primaryContrast: ['primaryContrast', 'primaryMain400'],
};

export type StatusTagProps = {
  type: StatusTagType;
  big?: boolean;
  text: string;
  icon?: IconProp;
  sx?: SxProps<Theme>;
};
export const statusTag = (
  type: StatusTagProps['type'],
  text: string,
): StatusTagProps => ({
  type,
  text,
});

export const StatusTag = (p: StatusTagProps) => (
  <Typography
    variant={p.big ? 'body1' : 'caption'}
    sx={{
      p: 0.5,
      paddingRight: 1.5,
      paddingLeft: 1.5,
      color: colors[statusColorMap[p.type][0]],
      background: colors[statusColorMap[p.type][1]],
      textTransform: 'uppercase',
      borderRadius: '14px',
      ...(p.sx || {}),
    }}
  >
    {p.text}
    {!p.icon ? null : (
      <FontAwesomeIcon style={{ paddingLeft: '7px' }} icon={p.icon} />
    )}
  </Typography>
);

export const StatusTags = (p: {
  tags: Array<StatusTagProps>;
  sharedProps?: Partial<StatusTagProps>;
}) => (
  <div className="flex gap-2">
    {p.tags.map((tag, i) => (
      <StatusTag {...(p.sharedProps || {})} {...tag} key={i} />
    ))}
  </div>
);
